export default {"src":"/_next/static/image/public/images/ic_warning_white.a3494b8efa9a4c5f7db5b9d0fbe0c624.svg","height":17,"width":17};